import { CLAIM_CURRENCY_INPUT_WIDTH } from "../formDefConstants.js";

/**
 * Regulierungsempfehlung — the broker's settlement recommendation to the
 * insurer. All-family section (mirrors sections/payment.js); imported into every
 * family formdef so the schmidt broker "Regulierung" step can pull these by name.
 */
export const regulierungSection = {
  label: "Regulierung",
  description: "Ihre Regulierungsempfehlung an den Versicherer.",
  children: [
    {
      control: "select",
      name: "regulierung_empfehlung",
      label: "Empfehlung",
      cols: "12",
      options: [
        {
          key: "Regulierung nach Sach- und Rechtslage",
          label: "Regulierung nach Sach- und Rechtslage",
        },
        {
          key: "Abwehr unbegründeter/überhöhter Ansprüche",
          label: "Abwehr unbegründeter/überhöhter Ansprüche",
        },
        {
          key: "Regulierung in bestimmter Höhe",
          label: "Regulierung in bestimmter Höhe",
        },
      ],
    },
    {
      control: "numberinput",
      unit_type: "currency",
      unit: "€",
      allow_negative: false,
      name: "regulierung_betrag",
      label: "Betrag",
      input_width: CLAIM_CURRENCY_INPUT_WIDTH,
      cols: "6",
      hidden:
        "isNotEqualOther('regulierung_empfehlung', 'Regulierung in bestimmter Höhe')",
    },
    {
      control: "select",
      name: "regulierung_auszahlung_an",
      label: "Auszahlung an",
      cols: "6",
      options: [
        { key: "Versicherungsnehmer", label: "Versicherungsnehmer" },
        { key: "Anspruchsteller", label: "Anspruchsteller" },
        { key: "Werkstatt / Handwerker", label: "Werkstatt / Handwerker" },
      ],
      hidden:
        "isNotEqualOther('regulierung_empfehlung', 'Regulierung in bestimmter Höhe')",
    },
    {
      control: "textarea",
      name: "regulierung_bemerkungen",
      label: "Zusätzliche Bemerkungen",
      cols: "12",
    },
  ],
};
